import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Search", -1)

import { ref, onMounted } from "vue"
  import { useResourcesStore } from "@/store/resources"
  import { useRouter, useRoute } from "vue-router"
  import { IonToolbar, IonHeader, IonNavLink, IonButton, IonButtons, IonBackButton, IonSelect, IonSelectOption } from "@ionic/vue"
  import { search } from "ionicons/icons"
  import CardTemplate from "@/components/template/CardTemplate.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceSearchpage',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const resourcesStore = useResourcesStore()

  const query = ref({
    offset: 0,
    format: "all",
    audience: "All",
    topic: "All",
  })
  const formatFilters = ["all", "article", "podcast", "e-book"]
  const audienceFilters = ["All", "Employers", "Professionals"]
  const topicsData = [
    "All",
    "Benefits & Perks",
    "Career Advice",
    "Career Progression",
    "Challenge Work",
    "Community Contribution",
    "Company Culture",
    "Company Reputation",
    "Diversity/Inclusion",
    "Employee Empowerment",
    "Employee Recognition",
    "Employer Branding",
    "Fun & Passion",
    "Innovation",
    "Job Flexibility",
    "Job Hunting",
    "Job Satisfaction",
    "Job Stability",
    "Leadership",
    "Learning & Development",
    "People Management",
    "Teams",
    "Technology",
    "Traditions & Events",
    "Vision, Mission & Values",
    "Work-Life Balance",
    "Work Environment",
  ]

  /**
   * clear filters
   */
  const clearQuery = () => (query.value = { offset: 0, format: "all", audience: "All", topic: "All" })

  /**
   * set query
   */
  const setQuery = () => {
    router.push(
      `/resources${query.value.format !== "all" ? `/${query.value.format}` : ""}?audience=${query.value.audience}&topic=${query.value.topic
        .replace("&", "%26")
        .replace(",", "%2C")
        .replace("/", "%2F")}`
    )
  }

  onMounted(() => {
    query.value = { ...resourcesStore.resourcesFilters }
    query.value.format = query.value.format.toLowerCase()
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonNavLink), { "router-direction": "back" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonBackButton), { disabled: true })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { class: "ion-padding" }, {
      default: _withCtx(() => [
        _createVNode(CardTemplate, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { position: "floating" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Filter")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      modelValue: query.value.format,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query.value.format) = $event)),
                      class: "capitalize",
                      placeholder: "Select format"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(formatFilters, (format) => {
                          return _createVNode(_unref(IonSelectOption), {
                            key: `${format}_id`,
                            value: format,
                            class: "capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(format), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { position: "floating" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Audience")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      modelValue: query.value.audience,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((query.value.audience) = $event)),
                      class: "capitalize",
                      placeholder: "Select audience"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(audienceFilters, (audience) => {
                          return _createVNode(_unref(IonSelectOption), {
                            key: `${audience}_id`,
                            value: audience,
                            class: "capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(audience), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { position: "floating" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Topics")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      modelValue: query.value.topic,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((query.value.topic) = $event)),
                      class: "capitalize",
                      placeholder: "Select topic"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(topicsData, (topic) => {
                          return _createVNode(_unref(IonSelectOption), {
                            key: `${topic}_id`,
                            value: topic,
                            class: "capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(topic), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_footer, null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), { class: "p-5 min-h-one-third-screen" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonNavLink), {
              "router-direction": "back",
              class: "flex flex-col gap-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  expand: "block",
                  type: "button",
                  "native-type": "button",
                  class: "relative",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (setQuery()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      class: "text-[20px] absolute left-0",
                      icon: _unref(search)
                    }, null, 8, ["icon"]),
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButton), {
              expand: "block",
              type: "button",
              "native-type": "button",
              color: "white",
              class: "text-primary-violet font-bold shadow-base",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (clearQuery()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Clear")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})